import { createAction, props } from '@ngrx/store';
import { StateLicensureAttachment } from '../../state-licensure/grid/models/state-licensure-details.model';
import { LicensureDetails } from 'src/app/compliance/models/licensure-details.model';
import { ListItem } from 'src/app/shared/models/list-item.model';

export const toggleEditMode = createAction(
    '[STATE LICENSURE DETAILS EDIT MODE COMPONENT] Toggle State Licensure Edit Mode',
    props<{ isEditMode: boolean }>()
);
export const toggleAdminEditMode = createAction(
    '[STATE LICENSURE DETAILS ADMIN EDIT MODE COMPONENT] Toggle State Licensure Admin Edit Mode',
    props<{ isAdminEditMode: boolean }>()
);
export const getStateDetails = createAction(
    '[STATE LICENSURE DETAILS GET COMPONENT] Get State Licensure Details',
    props<{ stateId: number }>()
);
export const getStateDetailsSuccess = createAction(
    '[STATE LICENSURE DETAILS SUCCESS API] State Licensure Details Success',
    props<{ details: LicensureDetails }>()
);
export const getStateDetailsFailure = createAction(
    '[STATE LICENSURE DETAILS FAILURE API] State Licensure Details Failure',
    props<{ error: any }>()
);
export const getStateDetailsAttachments = createAction(
    '[STATE LICENSURE DETAILS GET ATTACHMENTS COMPONENT] Get State Licensure Details Attachments',
    props<{ stateId: number }>()
);
export const getStateDetailsAttachmentsSuccess = createAction(
    '[STATE LICENSURE DETAILS ATTACHMENTS SUCCESS API] State Licensure Details Attachments Success',
    props<{ attachments: StateLicensureAttachment[] }>()
);
export const getStateDetailsAttachmentsFailure = createAction(
    '[STATE LICENSURE DETAILS ATTACHMENTS FAILURE API] State Licensure Details Attachments Failure',
    props<{ error: any }>()
);
export const downloadStateDetailsFileAttachment = createAction(
    '[STATE LICENSURE DETAILS DOWNLOAD FILE COMPONENT] Get State Licensure Details Download File  Attachment',
    props<{ stateId: number; fileId: number; fileName: string }>()
);
export const downloadStateDetailsFileAttachmentSuccess = createAction(
    '[STATE LICENSURE DETAILS DOWNLOAD FILE SUCCESS API] State Licensure Details Download File Attachment Success',
    props<{ blob: Blob; fileName: string }>()
);
export const downloadStateDetailsFileAttachmentFailure = createAction(
    '[STATE LICENSURE DETAILS DOWNLOAD FILE FAILURE API] State Licensure Details Download File Attachment Failure',
    props<{ error: any }>()
);
export const getProjectTypes = createAction(
    '[STATE LICENSURE DETAILS GET PROJECT TYPES COMPONENT] Get State Licensure Details Project Types'
);
export const getProjectTypesSuccess = createAction(
    '[STATE LICENSURE DETAILS PROJECT TYPES SUCCESS API] State Licensure Details Project Types Success',
    props<{ projectTypes: any }>()
);
export const getProjectTypesFailure = createAction(
    '[STATE LICENSURE DETAILS PROJECT TYPES FAILURE API] State Licensure Details Project Types Failure',
    props<{ error: any }>()
);
export const deleteStateDetailsFileAttachment = createAction(
    '[STATE LICENSURE DETAILS DELETE FILE COMPONENT] Get State Licensure Details Delete File Attachment',
    props<{ stateId: number; fileId: number }>()
);
export const deleteStateDetailsFileAttachmentSuccess = createAction(
    '[STATE LICENSURE DETAILS DELETE FILE SUCCESS API] State Licensure Details Delete File Attachment Success',
    props<{ stateId: number; file: any }>()
);
export const deleteStateDetailsFileAttachmentFailure = createAction(
    '[STATE LICENSURE DETAILS DELETE FILE FAILURE API] State Licensure Details Delete File Attachment Failure',
    props<{ error: any }>()
);
export const uploadStateDetailsFile = createAction(
    '[STATE LICENSURE DETAILS Upload FILE COMPONENT] State Licensure Details Upload File',
    props<{ stateId: number; file: any }>()
);
export const uploadStateDetailsFileSuccess = createAction(
    '[STATE LICENSURE DETAILS Upload FILE API] State Licensure Details Upload File Success',
    props<{ stateId: number; file: any }>()
);
export const uploadStateDetailsFileFailure = createAction(
    '[STATE LICENSURE DETAILS Upload FILE API] State Licensure Details Upload File Failure',
    props<{ error: any }>()
);
export const getAdmins = createAction(
    '[STATE LICENSURE DETAILS GET ADMINS COMPONENT] Get State Licensure Details Get Admins'
);
export const getAdminsSuccess = createAction(
    '[STATE LICENSURE DETAILS ADMINS SUCCESS API] State Licensure Details Get Admins Success',
    props<{ admins: ListItem[] }>()
);
export const getAdminsFailure = createAction(
    '[STATE LICENSURE DETAILS ADMINS FAILURE API] State Licensure Details Get Admins Failure',
    props<{ error: unknown }>()
);
export const updateDetailLic = createAction(
    '[STATE LICENSURE DETAILS UPDATE COMPONENT] Update Detail Lic',
    props<{ detail: LicensureDetails; stateId: number; id: number }>()
);
export const updateDetailLicSuccess = createAction(
    '[STATE LICENSURE DETAILS UPDATE SUCCESS API] Update Detail Lic Success',
    props<{ stateId: number }>()
);
export const updateDetailLicFailure = createAction(
    '[STATE LICENSURE DETAILS UPDATE FAILURE API] Update Detail Lic Failure',
    props<{ error: any }>()
);
